import set from 'lodash/set';
import {
  FETCH_INDEX_SEO_START,
  FETCH_INDEX_SEO_SUCCESS,
  FETCH_INDEX_SEO_FAILED,
} from './constants';
import defaultState from '../state';

const initialState = defaultState.index;

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INDEX_SEO_START:
      return { ...state, isFetching: true, error: null };

    case FETCH_INDEX_SEO_SUCCESS: {
      const { response, whereIn, verticalName, categoryId, letter } = action.data;
      let numResults = action.data.numResults;

      let data;
      switch (verticalName) {
        case 'cars': {
          data = response.filter(keyword => keyword.totalResults > 1);
          break;
        }
        case 'products': {
          numResults = response.meta.num_results;
          data = response;
          break;
        }
        default:
          // homes
          data = response.filter(keyword => keyword.totalResults > 1);
          break;
      }

      if (whereIn.length > 0) {
        // DANGER: in homes seo [] becomes an object
        // TODO: in this piece of state exists an ambiguity between 'seo' being an object (homes, because of propertyTypes) and the other verticals.
        // Recommended to separate this concepts.
        const seo = state.seo;
        data = set(Array.isArray(seo) && seo.length === 0 ? {} : seo, whereIn, data);
      }

      return {
        ...state,
        isFetching: false,
        seo: data,
        categoryId: categoryId || 0, // products category id
        letter: letter || '', // products topsearches filter results by letter
        numResults,
        error: null,
      };
    }

    case FETCH_INDEX_SEO_FAILED:
      return { ...state, isFetching: false, error: action.error };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Index/reducer.js